import { Component, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("[ErrorBoundary] React render error:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-white px-4">
          <div className="text-center max-w-md">
            <div className="w-16 h-16 rounded-full bg-rose-100 flex items-center justify-center mx-auto mb-6">
              <i className="ri-error-warning-line text-rose-600 text-2xl" />
            </div>
            <h1 className="font-display text-xl font-bold text-stone-800 mb-2">
              頁面載入發生錯誤
            </h1>
            <p className="font-body text-sm text-stone-500 mb-4">
              請嘗試重新整理頁面，或稍後再試。
            </p>
            {this.state.errorMessage && (
              <div className="bg-stone-50 rounded-lg p-3 text-left">
                <p className="font-body text-xs text-stone-400 mb-1">錯誤詳情：</p>
                <p className="font-mono text-xs text-rose-600 break-all">
                  {this.state.errorMessage}
                </p>
              </div>
            )}
            <button
              onClick={() => window.location.reload()}
              className="mt-6 inline-flex items-center gap-2 font-body text-sm font-semibold px-6 py-2.5 rounded-full bg-rose-800 text-white hover:bg-rose-900 transition-colors cursor-pointer"
            >
              <i className="ri-refresh-line" />
              重新整理
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}